import { useState, useEffect } from 'react';
import { adminApi } from '../api.js';
import AdminInfluencers from './AdminInfluencers.jsx';
import AdminConfig from './AdminConfig.jsx';
import AdminQuestionnaire from './AdminQuestionnaire.jsx';
import AdminTier3Codes from './AdminTier3Codes.jsx';

const MENU_ITEMS = [
  { key: 'influencers', label: '达人审核', icon: '👤' },
  { key: 'config', label: '文案配置', icon: '📝' },
  { key: 'questionnaire', label: '问卷选项', icon: '📋' },
  { key: 'tier3codes', label: '兑换码管理', icon: '🔑' },
  { key: 'weights', label: '权重管理', icon: '⚖️', placeholder: true },
  { key: 'products', label: '商品管理', icon: '🛒', placeholder: true },
];

export default function AdminDashboard() {
  const [active, setActive] = useState('influencers');
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    adminApi.getInfluencers('pending').then(data => setPendingCount((data.list || []).length)).catch(() => {});
  }, [active]);

  const handleLogout = () => {
    adminApi.logout();
    window.history.replaceState(null, '', '/admin/login');
    window.location.href = '/admin/login';
  };

  const renderContent = () => {
    if (active === 'influencers') return <AdminInfluencers />;
    if (active === 'config') return <AdminConfig />;
    if (active === 'questionnaire') return <AdminQuestionnaire />;
    if (active === 'tier3codes') return <AdminTier3Codes />;
    if (active === 'weights' || active === 'products') {
      return (
        <div className="admin-placeholder">
          <div className="admin-placeholder-icon">{MENU_ITEMS.find(m => m.key === active)?.icon}</div>
          <h2>开发中</h2>
          <p>该模块正在建设中，敬请期待</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <span className="admin-sidebar-logo">💄</span>
          <span className="admin-sidebar-title">管理后台</span>
        </div>
        <nav className="admin-nav">
          {MENU_ITEMS.map(item => (
            <button
              key={item.key}
              className={'admin-nav-item' + (active === item.key ? ' admin-nav-item--active' : '')}
              onClick={() => !item.placeholder && setActive(item.key)}
              disabled={item.placeholder}
            >
              <span>{item.icon} {item.label}</span>
              {item.placeholder && <span className="admin-nav-badge">开发中</span>}
              {item.key === 'influencers' && pendingCount > 0 && !item.placeholder && (
                <span className="admin-nav-badge" style={{ background: '#fdf2f8', color: '#db2777', border: '1px solid #fbcfe8' }}>
                  {pendingCount} 待审
                </span>
              )}
            </button>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={handleLogout}>退出登录</button>
        </div>
      </aside>
      <main className="admin-main">
        <div className="admin-topbar">
          <h1 className="admin-page-title">
            {MENU_ITEMS.find(m => m.key === active)?.icon} {MENU_ITEMS.find(m => m.key === active)?.label}
          </h1>
          <span className="admin-greeting">
            {active === 'influencers' && pendingCount > 0
              ? `${pendingCount} 位达人申请待处理`
              : '管理你的美妆报告系统'}
          </span>
        </div>
        <div className="admin-content">{renderContent()}</div>
      </main>
    </div>
  );
}
